import script from "./account-main-recharge-record-dialog.vue?vue&type=script&lang=tsx&name=account-main-recharge-record-dialog&setup=true"
export * from "./account-main-recharge-record-dialog.vue?vue&type=script&lang=tsx&name=account-main-recharge-record-dialog&setup=true"

const __exports__ = script;

export default __exports__